// Filename - components/Sidebar.js

// import React, { useState } from "react";
// import styled from "styled-components";
// import { Link } from "react-router-dom";
// import * as FaIcons from "react-icons/fa";
// import { IconContext } from "react-icons/lib";

// Filename - components/Sidebar.js

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import {alpha, Box } from '@mui/system';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import axios from 'axios';


import "../components/Scrollbar.css";
import { SidebarData } from "../components/SidebarData";
import SubMenu from "../components/SubMenu";
import AirportSearch from "../components/AirportSearch"
import SummaryBox from "../components/SummaryBox";
import EpochSlider from "../components/EpochSlider";
import {roundToNthNearestMinute} from "../utils/funcs.js"

const ContentLayout = styled.div`
    margin-top:10px;
    
    margin-right:10px;
    margin-bottom:10px;
    display:flex;
    background:white;
    justify-content: flex-start;
    flex-wrap:wrap;
    flex:1;
    gap:10px 10px;
    transition: 350ms;
`;

const SummaryBoxLayout = styled.div`
    display:flex;
    background:white;
    justify-content: flex-start;
    gap:20px 20px;
    flex-wrap:wrap;
    flex: 1 1 auto;
    overflow-y: scroll;
    margin-bottom:10;
    max-height: calc(100vh - 150px);
`;


const EpochControlLayout = styled.div`
    display:flex;
    justify-content:space-between;
    width:100%;
    margin-top:20px;
    margin-bottom:10px;
`;

const LookBackDuration = 48*60 //minutes over 2 days


const SliderValueStyle=styled.div`
    text-align:right;
    width:140px;
    font-family:Inter,sans-serif;
    font-size:15px;
    font-weight:bold;
    margin-bottom:0.5rem;
    margin-left:1rem;
`;


interface SliderValueLabelProps {
  children: React.ReactElement;
}

function SliderValueLabel({ children }: SliderValueLabelProps) {
  return <span className="valueLabel">{children}</span>;
}

function getDateFromEpochRef(sliderVal,maxVal,currentEpoch){
    const MS_PER_MINUTE = 60000;
    var diffMinutes = maxVal - sliderVal
    var epoch = new Date(currentEpoch - diffMinutes * MS_PER_MINUTE);
    return epoch
};

function apiQueryDateFormatting(sliderVal,maxVal,currentEpoch) {
    var epoch = getDateFromEpochRef(sliderVal,maxVal,currentEpoch);
    var epochString = epoch.toLocaleDateString("en-US",{month:'short'})+
                      epoch.toLocaleDateString("en-US",{day:'2-digit'})+
                      epoch.toLocaleString("en-US",{hour:'2-digit',hour12:false})+
                      epoch.toLocaleString("en-US",{minute:'2-digit',hour12:false})
    return epochString
};

function summaryBoxDateFormatting(sliderVal,maxVal,currentEpoch) {
    var epoch = getDateFromEpochRef(sliderVal,maxVal,currentEpoch);
    var epochString = epoch.toLocaleDateString("en-US",{month:'2-digit'})+'-'+
                      epoch.toLocaleDateString("en-US",{day:'2-digit'})+' '+
                      epoch.toLocaleString("en-US",{hour:'2-digit',hour12:false})+':'+
                      epoch.toLocaleString("en-US",{minute:'2-digit',hour12:false})
    return epochString
};

function sliderDateDisplayFormatting(sliderVal,maxVal,currentEpoch) {
    var epoch = getDateFromEpochRef(sliderVal,maxVal,currentEpoch);
    var options = {month:'short',day:'numeric',
                   hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false}
    var epochString = epoch.toLocaleDateString("en-US",options)
    
    return epochString
  
  //`${selectedEpochString}`;
};

function getUTCTimeNow(){
  return (Date.now())
}

// rgba(149, 157, 165, 0.2) 0px 8px 24px;
const NasWideSummary = ({setTitle,pageTitle,airportDataList,setActiveAirport,coloringThresholds,setActiveMetric,setMetricSelectedIndex,summaryMetricIndex,metricLookBackHorizonDays,backendApiPrefix}) => {
    
    useEffect(() => {
        setTitle(pageTitle=>'')
    },[]);
    
    var startVal = 0
    var endVal   = LookBackDuration
    var ep = roundToNthNearestMinute(getUTCTimeNow(),1)
    const [currentEpoch,setCurrentEpoch] = useState(ep)
    const [selectedEpochString, setSelectedEpochString] = useState(apiQueryDateFormatting(endVal,endVal,ep));
    const [displayEpochString, setDisplayEpochString]   = useState(summaryBoxDateFormatting(endVal,endVal,ep));
    
    const [selectedEpoch, setSelectedEpoch] = useState(getDateFromEpochRef(endVal,endVal,ep));
    
    const [selectedVal, setSelectedVal] = useState(LookBackDuration);
    
    const [latestEpochFlag, setLatestEpochFlag] = useState(true);
    
    const [airportList, setAirportList] = useState([]);
      
    
    
    //const [airportDataList, setAirportDataList] = useState([]);
    useEffect(() => {
        setAirportList(Object.keys(airportDataList));
      }, [airportDataList]);
      
    const handleButtonClick = () =>{
        setLatestEpochFlag(true)
        setSelectedVal(endVal);
        setSelectedEpochString(apiQueryDateFormatting(endVal,endVal,currentEpoch))
        setSelectedEpoch(getDateFromEpochRef(endVal,endVal,currentEpoch))
        setDisplayEpochString(summaryBoxDateFormatting(endVal,endVal,currentEpoch))
    };
    
    useEffect(() => {
        const interval = setInterval(() => {
          if(latestEpochFlag){
            var current_ep = roundToNthNearestMinute(getUTCTimeNow(),1) 
            
            setCurrentEpoch(current_ep);
            setSelectedEpochString(apiQueryDateFormatting(endVal,endVal,current_ep))
            setSelectedEpoch(getDateFromEpochRef(endVal,endVal,current_ep))
            setDisplayEpochString(summaryBoxDateFormatting(endVal,endVal,current_ep))            
          }
        }, 1000);
        return () => clearInterval(interval);
      }, [latestEpochFlag]);
        
    
    var timeout;
    const handleSliderChange = (event, newValue) => {
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => {
            setLatestEpochFlag(false)
            setSelectedVal(newValue)    
            setSelectedEpochString(apiQueryDateFormatting(newValue,endVal,currentEpoch))
            setSelectedEpoch(getDateFromEpochRef(newValue,endVal,currentEpoch))
            setDisplayEpochString(summaryBoxDateFormatting(newValue,endVal,currentEpoch))
        }, 20);
      };
     
    return (
        <>
        <ContentLayout>
        <EpochControlLayout>
        <Box sx={{ width: '100%',mr:'2%'}}>
          <EpochSlider
            aria-label="Epochs"
            defaultValue={selectedVal}
            valueLabelFormat={value => <SliderValueStyle>
                                        {sliderDateDisplayFormatting(value,endVal,currentEpoch)}
                                       </SliderValueStyle>}
            shiftStep={1}
            step={1}
                            
            onChange={handleSliderChange}
                            
            value={selectedVal}
            min={startVal}
            max={endVal}
            slots={{ valueLabel: SliderValueLabel }}
          />
        </Box>
        <Button style={{height:'32px',minWidth: '145px', maxWidth: '145px'}} 
                variant="contained" onClick={handleButtonClick}>Latest Epoch</Button>
        </EpochControlLayout>
            <SummaryBoxLayout>
                {airportList.map((item, index) => {
                        return (
                        <SummaryBox airport={item} 
                                    metroplex={airportDataList[item]['metroplex']}
                                    latestEpochFlag={latestEpochFlag}
                                    selectedEpochString={selectedEpochString}
                                    selectedEpoch={selectedEpoch}
                                    displayEpochString={displayEpochString}
                                    setActiveAirport={setActiveAirport}
                                    setActiveMetric={setActiveMetric}
                                    setMetricSelectedIndex={setMetricSelectedIndex}
                                    summaryMetricIndex={summaryMetricIndex}
                                    metricLookBackHorizonDays={metricLookBackHorizonDays}
                                    setTitle={setTitle}
                                    coloringThresholds={coloringThresholds}
                                    backendApiPrefix={backendApiPrefix}
                                    key={index}/>
                );
                }
                )}
            </SummaryBoxLayout>
        </ContentLayout>
        </>
        
    );
};


export default NasWideSummary;
